import {
  SSProfilesProvider,
  UpdateSSProfilePayload,
} from "./ssProfiles.provider";
import { failure, Result, success } from "../shared";
import { SSProfile } from "./ssProfiles.types";

export enum SSProfilesServiceErrorCode {
  GENERIC,
}

export class SSProfilesService {
  constructor(private profilesProvider: SSProfilesProvider) {}

  public async get(subscriberId: string): Promise<Result<SSProfile[]>> {
    try {
      const { data } = await this.profilesProvider.get(subscriberId);

      return success(data.profiles);
    } catch (error) {
      return failure(SSProfilesServiceErrorCode.GENERIC);
    }
  }

  public async update(
    subscriberId: string,
    profileName: string,
    changedFields: UpdateSSProfilePayload
  ) {
    try {
      await this.profilesProvider.update(
        subscriberId,
        profileName,
        changedFields
      );

      return success();
    } catch (error) {
      return failure(SSProfilesServiceErrorCode.GENERIC);
    }
  }
}
